1<template>
  <div class="basicDataSummaryPk">
    <div class="filters">
      <el-form :inline="true">
        <!-- 时间 -->
        <el-form-item>
          <el-date-picker v-model="datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="print" style="float:right;">打印pdf</el-button>
        <!-- 提交button -->
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <div id="print">
      <el-row class="rowTop" :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-title bg-purple leftTop">园区基础信息</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="closeIcon" v-if="gardenData1.staffCount" @click="delStaffPk(1)">×</div>
          <div class="grid-title bg-purple">
            <el-select class="w280" v-model="gardenVal1" filterable placeholder="请选择" @change="selectChanged1">
              <el-option v-for="item in gardenList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
			<!-- <div>
				<el-image v-if="gardenData1.gardenLogo" :src="gardenData1.gardenLogo" style="display:inline-block;height: 57px;" fit="cover"></el-image>
			</div> -->
          </div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="closeIcon" v-if="gardenData2.staffCount" @click="delStaffPk(2)">×</div>
          <div class="grid-title bg-purple">
            <el-select class="w280" v-model="gardenVal2" filterable placeholder="请选择" @change="selectChanged2">
              <el-option v-for="item in gardenList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
			<!-- <div>
			    <el-image v-if="gardenData2.gardenLogo" :src="gardenData2.gardenLogo" style="display:inline-block;height: 57px;" fit="cover"></el-image>
			</div> -->
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="gardenName">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">园区名称</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.gardenName}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.gardenName}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">物业人数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.staffCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.staffCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">业主人数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.roomOwnerCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.roomOwnerCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">业主平均年龄</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.gardenAge}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.gardenAge}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">APP绑定人数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.appBindCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.appBindCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">楼栋数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.gardenGridCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.gardenGridCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">园区出入口数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.gardenGateCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.gardenGateCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">车场出入口数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.gateCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.gateCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">车位数量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.carPlaceCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.carPlaceCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">临时车缴费金额</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.carInOutTmpPayAmount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.carInOutTmpPayAmount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">资源点位数量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.venueCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.venueCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">资源点位收益金额</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.venueContractPrice}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.venueContractPrice}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">居家服务金额</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.maintainPrice}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.maintainPrice}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">工单总数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.maintainCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.maintainCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">业主报事总数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.maintainCountByUser}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.maintainCountByUser}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">巡检工单总数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.maintainCountByJob}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.maintainCountByJob}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">今年工单总数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.maintainCountYear}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.maintainCountYear}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">今年业主报事总数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.maintainCountByUserYear}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.maintainCountByUserYear}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">今年巡检工单数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.maintainCountByJobYear}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.maintainCountByJobYear}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">设备总数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.deviceCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.deviceCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">电梯总数</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.liftCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.liftCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">蓝牙门禁数量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.doorDeviceCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.doorDeviceCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">蓝牙梯控数量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.liftDeviceCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.liftDeviceCount}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22">
          <div class="grid-content bg-purple leftLabel">园区鹰眼数量</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-00b1c3">{{gardenData1.videoMonitorInterfaceCount}}</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="grid-content bg-purple c-ed8599">{{gardenData2.videoMonitorInterfaceCount}}</div>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="6" class="w-22 h200">
          <div class="grid-content bg-purple leftLabel">接单及时率统计</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echart1"></div>
          </div>
          <!-- 图片
          <el-image id="echartImg" :src="gardenData1.img1"></el-image> -->
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echarts1"></div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22 h200">
          <div class="grid-content bg-purple leftLabel">工单满意率统计</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echart4"></div>
          </div>
          <!-- 图片
          <el-image id="echartImg" :src="gardenData1.img1"></el-image> -->
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echarts4"></div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22 h200">
          <div class="grid-content bg-purple leftLabel">接单完结率统计</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echart5"></div>
          </div>
          <!-- 图片
          <el-image id="echartImg" :src="gardenData1.img1"></el-image> -->
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echarts5"></div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22 h200">
          <div class="grid-content bg-purple leftLabel">工单类型统计</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echart6"></div>
          </div>
          <!-- 图片
          <el-image id="echartImg" :src="gardenData1.img1"></el-image> -->
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echarts6"></div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22 h200">
          <div class="grid-content bg-purple leftLabel">物业费收取统计</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echart2"></div>
          </div>
          <!-- 图片
          <el-image id="echartImg" :src="gardenData1.img1"></el-image> -->
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echarts2"></div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="6" class="w-22 h200">
          <div class="grid-content bg-purple leftLabel">车位费收取统计</div>
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echart3"></div>
          </div>
          <!-- 图片
          <el-image id="echartImg" :src="gardenData1.img1"></el-image> -->
        </el-col>
        <el-col :span="6" class="w-26">
          <div class="container">
            <div id="echarts3"></div>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:basicDataSummaryPk
   *@Description:物业人员数据pk
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2022-11-9
   */
  // import { mapGetters } from 'vuex'
  // import store from '@/store/store'
  import printHtml from '../../config/printGarden.js'
  import {
    mapGetters
  } from 'vuex'
  export default {
    name: '/manage/main.basicDataSummaryPk',
    data() {
      return {
        gardenId: this.$store.getters.gardenId, // 园区id
        startTs: '',
        endTs: '',
        datevalues: '',
        gardenList: [],
        gardenData1: {},
        gardenData2: {},
        gardenVal1: this.$store.getters.gardenId,
        gardenVal2: '',
      }
    },
    computed: {
      ...mapGetters({
        userGardenList: 'userGardenList'
      })
    },
    created() {
	this.getGardenLogo(1, this.gardenId)
      this.getGardenList()
      this.getGardenData(1, this.gardenId)
      this.getMaintainOverTime(1, this.gardenId)
      this.getPayInfowy(1, this.gardenId)
      this.getPayInfocar(1, this.gardenId)
      this.getMaintainEvaluate(1, this.gardenId)
      this.getMaintainState(1, this.gardenId)
      this.getMaintainType(1, this.gardenId)
    },
    methods: {
      // pdf打印
      print() {
        // window.print()
        // setTimeout(() => {
        //   // 取自己页面需要打印内容的标签
        //   let printDocument = document.getElementById('print')
        //   // 取出需要打印的内容
        //   let printData = printDocument.innerHTML
        //   // 调用打印方法
        //   printHtml(printData)
        // }, 300)
        this.getPdf('#print', '园区数字画像对比')
      },
      // 根据时间段查询pk园区数据
      commit() {
        if (this.datevalues) {
          this.startTs = this.datevalues[0]
          this.endTs = this.datevalues[1]
        } else {
          this.startTs = ''
          this.endTs = ''
        }
        if (this.gardenVal1) {
		  this.getGardenLogo(1, this.gardenVal1)
          this.getGardenData(1, this.gardenVal1)
          this.getMaintainOverTime(1, this.gardenVal1)
          this.getPayInfowy(1, this.gardenVal1)
          this.getPayInfocar(1, this.gardenVal1)
          this.getMaintainEvaluate(1, this.gardenVal1)
          this.getMaintainState(1, this.gardenVal1)
          this.getMaintainType(1, this.gardenVal1)
        }
        if (this.gardenVal2) {
		  this.getGardenLogo(2, this.gardenVal2)
          this.getGardenData(2, this.gardenVal2)
          this.getMaintainOverTime(2, this.gardenVal2)
          this.getPayInfowy(2, this.gardenVal2)
          this.getPayInfocar(2, this.gardenVal2)
          this.getMaintainEvaluate(2, this.gardenVal2)
          this.getMaintainState(2, this.gardenVal2)
          this.getMaintainType(2, this.gardenVal2)
        }
      },
      // 获取园区列表
      getGardenList() {
        this.gardenList = [...this.userGardenList].filter(item => item.id != 0)
      },
      // 获取园区基本信息数据
      getGardenData(index, id) {
        let loading = this.$loading()
        this.$get(
          `/selectBasicData?startTs=${this.startTs}&endTs=${this.endTs}&gardenId=` + id
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              var gardenData
              if (index == 1) {
                gardenData = this.gardenData1
              } else if (index == 2) {
                gardenData = this.gardenData2
              }
              this.$set(gardenData, 'carPlaceCount', res.carPlaceCount)
              this.$set(gardenData, 'gardenGridCount', res.gardenGridCount)
              this.$set(gardenData, 'gateCount', res.gateCount)
              this.$set(gardenData, 'maintainCount', res.maintainCount)
              this.$set(gardenData, 'maintainCountByJob', res.maintainCountByJob)
              this.$set(gardenData, 'maintainCountByUser', res.maintainCountByUser)
              this.$set(gardenData, 'maintainCountYear', res.maintainCountYear)
              this.$set(gardenData, 'maintainCountByJobYear', res.maintainCountByJobYear)
              this.$set(gardenData, 'maintainCountByUserYear', res.maintainCountByUserYear)
              this.$set(gardenData, 'roomOwnerCount', res.roomOwnerCount)
              this.$set(gardenData, 'staffCount', res.staffCount)
              this.$set(gardenData, 'gardenGateCount', res.gardenGateCount)
              this.$set(gardenData, 'gardenAge', Math.round(res.gardenAge))
              this.$set(gardenData, 'manCount', res.manCount)
              this.$set(gardenData, 'womanCount', res.womanCount)
              this.$set(gardenData, 'carInOutTmpPayAmount', res.carInOutTmpPayAmount)
              this.$set(gardenData, 'maintainPrice', res.maintainPrice)
              this.$set(gardenData, 'venueCount', res.venueCount)
              this.$set(gardenData, 'venueContractPrice', res.venueContractPrice)
              this.$set(gardenData, 'appBindCount', res.appBindCount)
              let name = [...this.userGardenList].filter(item => item.id == id)[0].name
              this.$set(gardenData, 'gardenName', name)
              // 获取设备信息数据
              this.$get(
                `/selectDeviceData?gardenId=` + id
              ).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    console.log(res)
                    this.$set(gardenData, 'deviceCount', res.deviceCount)
                    this.$set(gardenData, 'doorDeviceCount', res.doorDeviceCount)
                    this.$set(gardenData, 'liftCount', res.liftCount)
                    this.$set(gardenData, 'liftDeviceCount', res.liftDeviceCount)
                    this.$set(gardenData, 'videoMonitorInterfaceCount', res.videoMonitorInterfaceCount)
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 选择pk园区1
      selectChanged1(value) {
		this.getGardenLogo(1, value)
        this.getGardenData(1, value)
        this.gardenList = [...this.userGardenList].filter(item => item.id != value)
        this.getMaintainOverTime(1, value)
        this.getPayInfowy(1, value)
        this.getPayInfocar(1, value)
        this.getMaintainEvaluate(1, value)
        this.getMaintainState(1, value)
        this.getMaintainType(1, value)
        let name = [...this.userGardenList].filter(item => item.id == value)[0].name
        this.$set(this.gardenData1, 'gardenName', name)
      },
      // 选择pk园区2
      selectChanged2(value) {
		this.getGardenLogo(2, value)
        this.getGardenData(2, value)
        this.gardenList = [...this.userGardenList].filter(item => item.id != 0)
        this.getMaintainOverTime(2, value)
        this.getPayInfowy(2, value)
        this.getPayInfocar(2, value)
        this.getMaintainEvaluate(2, value)
        this.getMaintainState(2, value)
        this.getMaintainType(2, value)
        let name = [...this.userGardenList].filter(item => item.id == value)[0].name
        this.$set(this.gardenData2, 'gardenName', name)
      },
      // 移除pk园区
      delStaffPk(i) {
        if (i == 1) {
          this.gardenVal1 = ''
          this.gardenData1 = {}
          this.$echarts.init(document.getElementById('echart1')).dispose()
          this.$echarts.init(document.getElementById('echart2')).dispose()
          this.$echarts.init(document.getElementById('echart3')).dispose()
          this.$echarts.init(document.getElementById('echart4')).dispose()
          this.$echarts.init(document.getElementById('echart5')).dispose()
          this.$echarts.init(document.getElementById('echart6')).dispose()
        } else if (i == 2) {
          this.gardenVal2 = ''
          this.gardenData2 = {}
          this.$echarts.init(document.getElementById('echarts1')).dispose()
          this.$echarts.init(document.getElementById('echarts2')).dispose()
          this.$echarts.init(document.getElementById('echarts3')).dispose()
          this.$echarts.init(document.getElementById('echarts4')).dispose()
          this.$echarts.init(document.getElementById('echarts5')).dispose()
          this.$echarts.init(document.getElementById('echarts6')).dispose()
        }
        this.gardenList = [...this.userGardenList]
      },
      // 获取接单及时率数据
      getMaintainOverTime(index, id) {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainOverTime?startTs=${this.startTs}&endTs=${this.endTs}&gardenId=` + id
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (index == 1) {
                this.getLoadEchart1(res.data)
              } else {
                this.getLoadEcharts1(res.data)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取物业缴费数据
      getPayInfowy(index, id) {
        let loading = this.$loading()
        this.$get(
          `/selectPayInfo?startTs=${this.startTs}&endTs=${this.endTs}&gardenId=` + id + `&type=1`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.payInfo) {
                let data = []
                let isPay = {}
                let noPay = {}
                isPay.name = '实收'
                isPay.value = res.payInfo.paidAmountCount.toFixed(0)
                noPay.name = '未收'
                noPay.value = (res.payInfo.receiveAmountCount - res.payInfo.paidAmountCount).toFixed(0)
                if (isPay.value > 0) {
                  data.push(isPay)
                }
                if (noPay.value > 0) {
                  data.push(noPay)
                }
                if (index == 1) {
                  this.getLoadEchart2(data)
                } else {
                  this.getLoadEcharts2(data)
                }
              } else {
                if (index == 1) {
                  this.getLoadEchart2(null)
                } else {
                  this.getLoadEcharts2(null)
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取车位缴费数据
      getPayInfocar(index, id) {
        let loading = this.$loading()
        this.$get(
          `/selectPayInfo?startTs=${this.startTs}&endTs=${this.endTs}&gardenId=` + id + `&type=2`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.payInfo) {
                let data = []
                let isPay = {}
                let noPay = {}
                isPay.name = '实收'
                isPay.value = res.payInfo.paidAmountCount.toFixed(0)
                noPay.name = '未收'
                noPay.value = (res.payInfo.receiveAmountCount - res.payInfo.paidAmountCount).toFixed(0)
                data.push(isPay)
                data.push(noPay)
                if (index == 1) {
                  this.getLoadEchart3(data)
                } else {
                  this.getLoadEcharts3(data)
                }
              } else {
                if (index == 1) {
                  this.getLoadEchart3(null)
                } else {
                  this.getLoadEcharts3(null)
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取工单满意率数据
      getMaintainEvaluate(index, id) {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainEvaluate?startTs=${this.startTs}&endTs=${this.endTs}&gardenId=` + id
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              let data = res.data
              if (res.data.length == 4) {
                let arr = res.data
                data = [...arr];
                [data[0], data[1]] = [data[1], data[0]]
              }
              let arr = data.map((item) => {
                let obj = {}
                obj.name = item.name
                obj.value = item.value
                if (obj.name == '好评') {
                  obj.color = '#91CC75'
                } else if (obj.name == '中评') {
                  obj.color = '#6A89CC'
                } else if (obj.name == '差评') {
                  obj.color = '#F97F51'
                } else if (obj.name == '未评价') {
                  obj.color = '#FAC858'
                }
                return obj
              })
              if (index == 1) {
                this.getLoadEchart4(arr, data)
              } else {
                this.getLoadEcharts4(arr, data)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单完结率数据
      getMaintainState(index, id) {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainState?startTs=${this.startTs}&endTs=${this.endTs}&gardenId=` + id
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (index == 1) {
                this.getLoadEchart5(res.data)
              } else {
                this.getLoadEcharts5(res.data)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取工单类型统计数据
      getMaintainType(index, id) {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainTypeCount?startTs=${this.startTs}&endTs=${this.endTs}&gardenId=` + id
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.data.length > 5) {
                let data = res.data.sort(function (a, b) {
                  return a.value > b.value ? 1 : -1
                })
                let arr = (data.reverse()).splice(0, 5)
                if (index == 1) {
                  this.getLoadEchart6(arr)
                } else {
                  this.getLoadEcharts6(arr)
                }
              } else if (res.data.length <= 5 && res.data.length > 1) {
                let data = res.data.sort(function (a, b) {
                  return a.value > b.value ? 1 : -1
                })
                let arr = data.reverse()
                if (index == 1) {
                  this.getLoadEchart6(arr)
                } else {
                  this.getLoadEcharts6(arr)
                }
              } else {
                if (index == 1) {
                  this.getLoadEchart6(res.data)
                } else {
                  this.getLoadEcharts6(res.data)
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单及时率图表(园区一)
      getLoadEchart1(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart1')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart1 = this.$echarts.init(
            document.getElementById('echart1')
          )
          var option1 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: '接单率统计',
              type: 'pie',
              radius: ['25%', '65%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart1.setOption(option1)
          // 图片
          // let that = this
          // setTimeout(function () {
          //   var echartsimg = myChart1.getDataURL({
          //     pixelRatio: 2,
          //     backgroundColor: '#fff',
          //   })
          //   console.log(echartsimg)
          //   that.gardenData1.img1 = echartsimg
          // }, 1000)
        }
      },
      // 获取接单及时率图表(园区二)
      getLoadEcharts1(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echarts1')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart1 = this.$echarts.init(
            document.getElementById('echarts1')
          )
          var option1 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: '接单率统计',
              type: 'pie',
              radius: ['25%', '65%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart1.setOption(option1)
        }
      },
      // 获取物业费收缴率图表(园区一)
      getLoadEchart2(data) {
        if (!data) {
          var dom = document.getElementById('echart2')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart2 = this.$echarts.init(
            document.getElementById('echart2')
          )
          var option2 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#F97F51', '#6a89cc'],
            legend: {
              bottom: '0',
              left: '0'
            },
            series: [{
              name: '物业费收取统计',
              type: 'pie',
              radius: ['25%', '65%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data
            }]
          }
          myChart2.setOption(option2)
        }
      },
      // 获取物业费收缴率图表(园区一)
      getLoadEcharts2(data) {
        if (!data) {
          var dom = document.getElementById('echarts2')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart2 = this.$echarts.init(
            document.getElementById('echarts2')
          )
          var option2 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#F97F51', '#6a89cc'],
            legend: {
              bottom: '0',
              left: '0'
            },
            series: [{
              name: '物业费收取统计',
              type: 'pie',
              radius: ['25%', '65%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data
            }]
          }
          myChart2.setOption(option2)
        }
      },
      // 获取车位费收缴率图表(园区一)
      getLoadEchart3(data) {
        if (!data) {
          var dom = document.getElementById('echart3')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart3 = this.$echarts.init(
            document.getElementById('echart3')
          )
          var option3 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#F97F51', '#6a89cc'],
            legend: {
              bottom: '0',
              left: '0'
            },
            series: [{
              name: '车位费收取统计',
              type: 'pie',
              radius: ['25%', '65%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data
            }]
          }
          myChart3.setOption(option3)
        }
      },
      // 获取车位费收缴率图表(园区一)
      getLoadEcharts3(data) {
        if (!data) {
          var dom = document.getElementById('echarts3')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart3 = this.$echarts.init(
            document.getElementById('echarts3')
          )
          var option3 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#F97F51', '#6a89cc'],
            legend: {
              bottom: '0',
              left: '0'
            },
            series: [{
              name: '车位费收取统计',
              type: 'pie',
              radius: ['25%', '65%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data
            }]
          }
          myChart3.setOption(option3)
        }
      },
      // 获取工单满意率图表(园区一)
      getLoadEchart4(arr, data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart4')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var colorList = arr.map((item) => {
            return item.color
          })
          var myChart4 = this.$echarts.init(
            document.getElementById('echart4')
          )
          var option4 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: colorList,
            series: [{
              name: '工单满意率统计',
              type: 'pie',
              radius: ['25%', '65%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart4.setOption(option4)
        }
      },
      // 获取工单满意率图表(园区二)
      getLoadEcharts4(arr, data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echarts4')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var colorList = arr.map((item) => {
            return item.color
          })
          var myChart4 = this.$echarts.init(
            document.getElementById('echarts4')
          )
          var option4 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: colorList,
            series: [{
              name: '工单满意率统计',
              type: 'pie',
              radius: ['25%', '65%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart4.setOption(option4)
        }
      },
      // 获取接单完结率图表(园区一)
      getLoadEchart5(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart5')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart5 = this.$echarts.init(
            document.getElementById('echart5')
          )
          var option5 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: '接单完结率统计',
              type: 'pie',
              radius: ['25%', '65%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart5.setOption(option5)
        }
      },
      // 获取接单完结率图表(园区二)
      getLoadEcharts5(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echarts5')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart5 = this.$echarts.init(
            document.getElementById('echarts5')
          )
          var option5 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: '工单满意率统计',
              type: 'pie',
              radius: ['25%', '65%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart5.setOption(option5)
        }
      },
      // 获取工单类型图表(园区一)
      getLoadEchart6(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart6')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart6 = this.$echarts.init(
            document.getElementById('echart6')
          )
          var option6 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4', '#F97F51', '#6a89cc',
              '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4'
            ],
            series: [{
              name: '工单类型统计',
              type: 'pie',
              radius: ['25%', '65%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart6.setOption(option6)
        }
      },
      // 获取工单类型图表(园区二)
      getLoadEcharts6(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echarts6')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart6 = this.$echarts.init(
            document.getElementById('echarts6')
          )
          var option6 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4', '#F97F51', '#6a89cc',
              '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4'
            ],
            series: [{
              name: '工单类型统计',
              type: 'pie',
              radius: ['25%', '65%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart6.setOption(option6)
        }
      },
	  // 获取项目logo
	  getGardenLogo(index, id) {
	    this.$get(`/gardensById?gardenId=` + id).then(
			res => {
	            console.log(res)
	            if (res.list[0].gardenLogo) {
					var gardenData
					if (index == 1) {
	                  gardenData = this.gardenData1
	                } else if (index == 2) {
	                  gardenData = this.gardenData2
	                }
	                this.$set(gardenData, 'gardenLogo', res.list[0].gardenLogo)
	              }
	            },
	            err => {
	              this.$message.error(err)
	            }
	          )
	        },
    }
  }
</script>

<style lang="scss">
  .basicDataSummaryPk {
    .el-row {
      background: #fff;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .el-col {
      border-bottom: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;
      text-align: center;
    }

    .w-22 {
      width: 22%;
    }

    .w-26 {
      width: 38.7%;
    }

    .bg-purple {
      background: #fff;
      font-weight: bold;
    }

    .c-00b1c3 {
      color: #00b1c3;
    }

    .c-ed8599 {
      color: #ed8599;
    }

    .c-b4d049 {
      color: #b4d049;
    }

    .grid-title {
      // min-height: 36px;
      padding: 10px 0;
      line-height: 2.2;
      font-size: 24px;
    }

    .grid-content {
      min-height: 36px;
      line-height: 2.2;
    }

    .row-bg {
      padding: 10px 0;
      background-color: #fff;
    }

    .staffImg {
      display: block;
      width: 100px;
      height: 100px;
      margin: 10px auto 10px;
      border-radius: 50%;
    }

    .leftLabel {
      color: #386ed3;
      text-align: right;
      padding-right: 20px;
      font-size: 15px;
    }

    .rowTop {
      height: 100px;

      .el-col {
        height: 100%;
        background-color: #fff;
        position: relative;
      }

      .closeIcon {
        font-size: 32px;
        color: #999;
        position: absolute;
        right: 6px;
        top: -2px;
      }

      .leftTop {
        color: #386ed3;
        // line-height: 200px;
        margin-top: 10px;
        text-align: right;
        padding-right: 20px;
      }

      .w280 {
        width: 70%;
      }
    }

    .gardenName {
      display: none;
    }

    .contentBox {
      display: flex;
      margin: 20px 0;

      .contentCard {
        flex: 1;
        margin-right: 20px;
      }

      .contentCard:last-child {
        margin-right: 0;
      }

      .container {
        width: 100%;
        height: 280px;
        margin-left: 30px;
      }

      .gardenAge {
        margin-left: 24px;
        font-size: 18px;
        font-weight: bold;
        color: #999;

        span {
          font-size: 30px;
          color: #F97F51;
        }
      }
    }

    .h200 {
      height: 200px;
    }

    .container {
      width: 100%;
      height: 199px;
      margin-left: 30px;
    }

    // 图片
    // #echartImg{
    //   width:100%;
    //   height:90%;
    //   display:none !important;
    // }
    #echart1,
    #echart2,
    #echart3,
    #echart4,
    #echart5,
    #echart6,
    #echart7,
    #echart8,
    #echart9,
    #echarts1,
    #echarts2,
    #echarts3,
    #echarts4,
    #echarts5,
    #echarts6,
    #echarts7,
    #echarts8,
    #echarts9,
      {
      width: 90%;
      height: 100%;
    }
  }
</style>